import Skeleton from "react-loading-skeleton";
import { JSX } from "react";

export const ThankYouBackButtonSkeleton = (): JSX.Element => (
    <Skeleton
        containerClassName="p-checkout-thank-you-page__back-btn--skeleton"
        width={146}
        height={40}
        borderRadius={8}
    />
);

export const ThankYouContentSkeleton = (): JSX.Element => (
    <div className="p-checkout-thank-you-page__content-skeleton">
        <Skeleton
            height="3rem"
            width="60%"
            borderRadius={4}
            containerClassName="p-checkout-thank-you-page__title-skeleton"
        />
        <div className="p-checkout-thank-you-page__order-section-skeleton">
            <Skeleton height="18rem" borderRadius={8} />
        </div>
        <div className="p-checkout-thank-you-page__process-skeleton">
            <Skeleton height="2.7rem" width="30%" borderRadius={4} />
            <div className="p-checkout-thank-you-page__process-skeleton__cards">
                <Skeleton height="11.3rem" borderRadius={8} />
                <Skeleton height="11.3rem" borderRadius={8} />
                <Skeleton height="11.3rem" borderRadius={8} />
            </div>
        </div>
        <Skeleton height="4rem" borderRadius={8} />
    </div>
);
